import { render, staticRenderFns } from "./x-multiselect.vue?vue&type=template&id=ed7526d2&scoped=true&"
import script from "./x-multiselect.vue?vue&type=script&lang=js&"
export * from "./x-multiselect.vue?vue&type=script&lang=js&"
import style0 from "./x-multiselect.vue?vue&type=style&index=0&id=ed7526d2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7526d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ed7526d2', component.options)
    } else {
      api.reload('ed7526d2', component.options)
    }
    module.hot.accept("./x-multiselect.vue?vue&type=template&id=ed7526d2&scoped=true&", function () {
      api.rerender('ed7526d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-multiselect.vue"
export default component.exports